var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23 9.833q-1.932 0-3.268-1.337T.625 5.229q0-1.93 1.337-3.267T5.23.625t3.267 1.337T9.833 5.23a4.32 4.32 0 0 1-.92 2.692l3.966 3.966q.195.196.195.496 0 .301-.195.496a.67.67 0 0 1-.496.195.67.67 0 0 1-.495-.195L7.92 8.913a4.318 4.318 0 0 1-2.692.92m0-1.416q1.327 0 2.257-.93t.93-2.258q0-1.328-.93-2.258a3.07 3.07 0 0 0-2.258-.93q-1.328 0-2.258.93t-.93 2.258q0 1.329.93 2.258.93.93 2.258.93"
  })));
};
export default SvgSearch;